module.exports = __webpack_public_path__ + "d66a45c833a85723e943b4ceebe724b9.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/percent.svg
// module id = 209
// module chunks = 0